import { render, staticRenderFns } from "./GridPage.vue?vue&type=template&id=2394721b&scoped=true&"
import script from "./GridPage.vue?vue&type=script&lang=js&"
export * from "./GridPage.vue?vue&type=script&lang=js&"
import style0 from "./GridPage.vue?vue&type=style&index=0&id=2394721b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2394721b",
  null
  
)

export default component.exports